import React, { Component } from "react";
import { MenuItem, FormControl, InputLabel, Select } from "@material-ui/core";
import styled from "styled-components";

const StyledFormControl = styled(FormControl)`
  & {
    width: ${props => (props.width)};
  }
`;
const StyledInputLabel = styled(InputLabel)`& {
  /* Work Sans / 12 Semibold CAPS */
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  
  
  /* Text / Dark Gray */
  color: #5F6368;
  }
`;
class DropDownFormControl extends Component {
  render() {
    let { width } = this.props;
    width = width || "200px";

    return (
      <StyledFormControl width={width}>
        <StyledInputLabel htmlFor={this.props.htmlFor}>
          {this.props.labelName}
        </StyledInputLabel>
        <Select
          value={this.props.value}
          onChange={this.props.onChange}
          inputProps={this.props.inputProps}
          margin="dense"
          disabled={this.props.disabled}
        >
          {this.props.menuItemList.map(item => (
            <MenuItem key={item.value} value={item.value}>
              {item.name}
              {" "}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
    );
  }
}

export default DropDownFormControl;
